import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMessages, sendMessage } from "../../redux/actions/chat";
import { base, formatTime } from "../../constants/base";
import Pusher from "pusher-js";
import { toast } from "react-toastify";
import environment from "../../config/config";

const ChatBox = ({ id }) => {
  const dispatch = useDispatch();
  const messages = useSelector((state) => state.chat.messages);
  const user = useSelector((state) => state.AuthSlice.user);
  const [inputMessage, setInputMessage] = useState("");
  const [realTimeMessages, setRealTimeMessages] = useState([]);
  const [chatLoader, setChatLoader] = useState(false);
  const [file, setFile] = useState(null);
  const [type, setType] = useState(null);

  useEffect(() => {
    dispatch(getMessages(id));
    setRealTimeMessages([]);
  }, [id]);

  // Reference for scrolling

  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    // messagesEndRef.current?.scrollIntoView();
    messagesEndRef.current?.scrollTo({
      top: messagesEndRef.current.scrollHeight,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, realTimeMessages]);

  // Reference for scrolling

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (inputMessage.trim().length < 1) {
      toast.error("Please type message first.");
      return;
    }
    setChatLoader(true);
    const data = {
      sender_id: user?.id,
      receiver_id:
        messages?.data?.receiver?.id === user?.id
          ? messages?.data?.sender?.id
          : messages?.data?.receiver?.id,
      conversation_id: id,
      message: inputMessage,
      attachment: file,
      type: type,
    };

    try {
      const res = await dispatch(sendMessage(data));
      if (res?.payload?.data?.status === true || res?.payload?.status === 200) {
        const newMessage = res?.payload?.data?.data;
        if (newMessage) {
          setRealTimeMessages((prev) => [...prev, newMessage]);
        }
        setFile(null);
        setType(null);
      } else if (res?.payload?.exception) {
        toast.error("Failed to send message. Please try again.");
      }
    } catch (error) {
      toast.error("Failed to send message. Please try again.");
    } finally {
      setChatLoader(false);
      setInputMessage("");
    }
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      setFile(selectedFile);
      if (selectedFile.type == "application/pdf") {
        setType("file");
      } else {
        setType("image");
      }
    }
  };

  useEffect(() => {
    const pusher = new Pusher("2e603f5ea3523f08e7b7", {
      cluster: "ap2",
    });

    const channel = pusher.subscribe("my-chat-channel");
    channel.bind("my-chat-event", (data) => {
      const newMessage = data.message;
      // Only add message if it's from another user (to avoid duplicates for sent messages)
      if (newMessage?.sender_id !== user?.id && newMessage?.conversation_id == id) {
        setRealTimeMessages((prevMessages) => {
          // Check if message already exists
          const exists = prevMessages.some((msg) => msg.id === newMessage.id);
          if (!exists) {
            return [...prevMessages, newMessage];
          }
          return prevMessages;
        });
      }
    });

    // Cleanup
    return () => {
      channel.unbind_all();
      channel.unsubscribe();
    };
  }, [user?.id, id]);

  const handleDownload = (url) => {
    const fileUrl = base.imageUrl + url;
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "example-file.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (!messages?.data) {
    return (
      <div className="col-xl-9 col-lg-9 col-md-12">
        <div className="main-chat-box">
          <div className="text-center p-4">Loading messages...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="col-xl-9 col-lg-9 col-md-12">
      <div className="main-chat-box">
        <div className="user-data-show">
          <div className="user-image-side">
            <img
              className="message-image"
              src={
                messages?.data?.receiver?.id == user?.id
                  ? base.imageUrl + messages?.data?.sender?.images?.[0]?.path
                  : base.imageUrl + messages?.data?.receiver?.images?.[0]?.path
              }
              alt=""
            />
            <div className="user-name-status">
              <h2>
                {messages?.data?.receiver?.id == user?.id
                  ? messages?.data?.sender?.name
                  : messages?.data?.receiver?.name}
              </h2>
              {/* <h1>
                <span className="active-dot"></span> Active
              </h1> */}
            </div>
          </div>

          <div className="dropdown-box">
            <span className="blue-tag-btn">Hired</span>
          </div>
        </div>

        <div className="messages-box" ref={messagesEndRef}>
          {messages?.data?.messages &&
            messages.data.messages.map((message) =>
              message.sender_id === user?.id ? (
                <div className="send-message" key={message.id}>
                  {message?.attachment ? (
                    message?.attachment?.type === "image" ? (
                      // Render image if type is "image"
                      <img
                        src={base.imageUrl + message?.attachment?.path}
                        className="img-fluid rounded"
                        width={200}
                        alt="attachment"
                      />
                    ) : message?.attachment?.type === "file" ? (
                      // Render file card if type is "file"
                      <div className="card">
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <div className="d-flex align-items-center pl-3">
                              <i className="fa-solid fa-file-pdf"></i>
                              <span className="mx-2">
                                {message?.attachment?.path}
                              </span>
                            </div>
                            <div
                              onClick={() =>
                                handleDownload(message?.attachment?.path)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <i className="fa-regular fa-circle-down"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      // Render empty string for other cases
                      ""
                    )
                  ) : (
                    ""
                  )}

                  <p className="message-text">{message.message}</p>
                  <span className="message-time">
                    {formatTime(message.created_at)}
                  </span>
                </div>
              ) : (
                <div className="received-message" key={message.id}>
                  {message?.attachment ? (
                    message?.attachment?.type === "image" ? (
                      <div className="chat-image-box">
                        <img
                          src={base.imageUrl + message?.attachment?.path}
                          className="img-fluid rounded"
                          width={200}
                          alt="attachment"
                        />
                      </div>
                    ) : message?.attachment?.type === "file" ? (
                      <div className="card">
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <div className="d-flex align-items-center pl-3">
                              <i className="fa-solid fa-file-pdf"></i>
                              <span className="mx-2">
                                {message?.attachment?.path}
                              </span>
                            </div>
                            <div
                              onClick={() =>
                                handleDownload(message?.attachment?.path)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <i className="fa-regular fa-circle-down"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  <p className="message-text">{message.message}</p>
                  <span className="message-time">
                    {formatTime(message.created_at)}
                  </span>
                </div>
              )
            )}

          {realTimeMessages.map((message, index) =>
            message.sender_id == user?.id ||
            (message.receiver_id == user?.id &&
              message.conversation_id == id) ? (
              <div
                className={
                  message.sender_id == user?.id
                    ? "send-message"
                    : "received-message"
                }
                key={index}
              >
                {message?.attachment ? (
                  message?.attachment?.type === "image" ? (
                    <img
                      src={base.imageUrl + message?.attachment?.path}
                      className="img-fluid rounded"
                      width={200}
                      alt="attachment"
                    />
                  ) : message?.attachment?.type === "file" ? (
                    <div className="card">
                      <div className="card-body">
                        <div className="d-flex align-items-center">
                          <div className="d-flex align-items-center pl-3">
                            <i className="fa-solid fa-file-pdf"></i>
                            <span className="mx-2">
                              {message?.attachment?.path}
                            </span>
                          </div>
                          <div
                            onClick={() =>
                              handleDownload(message?.attachment?.path)
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <i className="fa-regular fa-circle-down"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                <p className="message-text">{message.message}</p>
                <span className="message-time">
                  {formatTime(message.created_at)}
                </span>

                <div></div>
              </div>
            ) : (
              ""
            )
          )}
          {chatLoader ? (
            <div className="loading text-center">sending...</div>
          ) : (
            ""
          )}
        </div>

        <form onSubmit={handleSendMessage} encType="">
          <div className="send-message-form">
            <input
              type="text"
              value={inputMessage}
              onChange={(e) => setInputMessage(e.target.value)}
              placeholder="Type your message.."
            />

            <div className="send-button-document-box">
              <i
                className="fa-solid fa-paperclip"
                style={{
                  position: "relative",
                  overflow: "hidden",
                  cursor: "pointer",
                  color: file && "#3236ff",
                }}
              >
                <input
                  style={{
                    position: "absolute",
                    fontSize: "50px",
                    opacity: 0,
                    right: 0,
                    top: 0,
                  }}
                  type="file"
                  accept=".pdf, .png, .jpeg, .jpg"
                  onChange={handleFileChange}
                />
              </i>
              <button
                type="submit"
                style={{
                  border: "none",
                  background: "transparent",
                }}
              >
                <i className="fa-solid fa-paper-plane"></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChatBox;
